import './manuscripts.scss';
import React from 'react';
import FilesWithReferenceFiles from './FilesWithReferenceFiles';
var Manuscripts = function Manuscripts(_ref) {
  var allowAnonymousUploads = _ref.allowAnonymousUploads,
    apiRoot = _ref.apiRoot,
    alertMessage = _ref.alertMessage,
    methods = _ref.methods;
  return /*#__PURE__*/React.createElement(FilesWithReferenceFiles, {
    allowAnonymousUploads: allowAnonymousUploads,
    apiRoot: apiRoot,
    className: "order-manuscripts",
    displayAcceptedFilesFormats: true,
    heading: "Your manuscript files",
    methods: methods,
    subheading: "accepted-file-format-listing",
    alertMessage: alertMessage,
    types: {
      main: 'main',
      reference: 'mainRef'
    },
    names: {
      main: 'mainFiles',
      reference: 'mainReferenceFiles'
    }
  });
};
export default Manuscripts;